import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';

const COMMON_EMOJIS = [
  '😀', '😊', '😂', '🤔', '😅', '😍', '🥰', '😎',
  '🤗', '🙂', '😉', '😋', '😘', '🤪', '🥳', '😇',
  '👍', '👎', '👌', '✌️', '🤞', '👏', '🙌', '💪',
  '❤️', '💙', '💚', '💛', '🧡', '💜', '🖤', '🤍',
  '🎉', '🎊', '🔥', '⭐', '✨', '💯', '💎', '🎯',
];

const EmojiPicker = ({ onEmojiSelect, isOpen }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`absolute bottom-full right-0 mb-1 z-[1000] transition-opacity duration-150 ${
        isOpen ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Card className="p-2 w-[300px] max-h-[200px] overflow-y-auto shadow-lg rounded-lg">
        <div className="grid grid-cols-8 gap-0.5">
          {COMMON_EMOJIS.map((emoji) => (
            <Button
              key={emoji}
              variant="ghost"
              size="icon"
              onClick={() => onEmojiSelect(emoji)}
              className="text-xl w-8 h-8 hover:scale-110 transition-transform duration-100"
            >
              {emoji}
            </Button>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default EmojiPicker;
